(function(window, undefined) {
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui', ['ui.bootstrap']);
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui').controller('ConfirmDialogModalController', ConfirmDialogModalController);
    /** @ngInject **/
    function ConfirmDialogModalController($rootScope, $uibModalInstance) {
      var vm = this;
      vm.confirm = function() {
        $uibModalInstance.close();
        $rootScope.$broadcast('confirm-dialog-modal-controller.confirm');
      };
      vm.cancel = function() {
        $uibModalInstance.dismiss('cancel');
        $rootScope.$broadcast('confirm-dialog-modal-controller.cancel');
      };
    }
    ConfirmDialogModalController.$inject = ['$rootScope', '$uibModalInstance'];
  })();
  /**
   * author andre.pitombeira
   *
   * Usage:
   *   <form ec-auto-save-form
   *         ec-auto-save-form-model='modelToBeSaved'
   *         ec-auto-save-form-fn='saveFunction()'>
   *   </form>
   *
   */
  (function() {
    'use strict';
    angular.module('ec.ui').directive('ecAutoSaveForm', ecAutoSaveForm);
    /** @ngInject **/
    function ecAutoSaveForm() {
      var directive = {
        restrict: 'A',
        require: 'form',
        scope: {
          ecAutoSaveFormFn: '&',
          ecAutoSaveFormModel: '=',
        },
        link: link,
      };
      return directive;
      function link(scope, elem, attrs, form) {
        var latestModel;
        function saveForm() {
          if (!angular.equals(latestModel, scope.ecAutoSaveFormModel) && form.$valid) {
            latestModel = angular.copy(scope.ecAutoSaveFormModel);
            scope.$apply(function() {
              scope.ecAutoSaveFormFn();
            });
          }
        }
        function keydownHandler(event) {
          var code = event.keyCode || event.which,
            ENTER_CODE = 13;
          if (code === ENTER_CODE) {
            event.preventDefault();
            event.target.blur();
          }
        }
        elem.find('input, textarea').on('blur', saveForm);
        elem.find('input, textarea').on('keydown', keydownHandler);
        elem.on('$destroy', function() {
          elem.find('input, textarea').off('blur', saveForm);
          elem.find('input, textarea').off('keydown', keydownHandler);
        });
      }
    }
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui').directive('ecBlurOnEnter', ecBlurOnEnter);
    /** @ngInject **/
    function ecBlurOnEnter($timeout) {
      var directive = {
        restrict: 'A',
        link: link,
      };
      return directive;
      function link(scope, elem) {
        elem.bind('keydown', function(event) {
          var code = event.keyCode || event.which,
            ENTER_CODE = 13;
          if (code === ENTER_CODE) {
            event.preventDefault();
            $timeout(function() {
              event.target.blur();
            });
          }
        });
      }
    }
    ecBlurOnEnter.$inject = ['$timeout'];
  })();
  /**
   * Dependency: the ZeroClipboard.js script must be included on the page
   * Usage: <button data-ec-copy-to-clipboard
   *                data-ec-model-builder-function="ctrlOnScope.builder" <- optional parameter
   *                data-ec-model-to-copy="ctrlOnScope.property"
   *                data-clipboard-target="#elementToCopyFrom" <- if flash disabled, content from this element will be copied (Chrome) or selected (Firefox/Safari)
   *        </button>
   */
  (function() {
    'use strict';
    angular.module('ec.ui').directive('ecCopyToClipboard', copyToClipboard);
    function copyToClipboard($window, $log) {
      return {
        restrict: 'A',
        scope: {
          ecModelToCopy: '=',
          ecModelBuilderFunction: '&',
        },
        link: function(scope, elem) {
          var zeroClipboard,
            modelBuilder = angular.isFunction(scope.ecModelBuilderFunction()) ? scope.ecModelBuilderFunction() : dummyBuilder,
            el = elem[0],
            watch;
          if (!$window.ZeroClipboard) {
            $log.info('Zeroclipboard object not loaded.');
            elem.addClass('disabled');
            return;
          }
          watch = scope.$watchCollection('ecModelToCopy', function(val) {
            el.setAttribute('data-clipboard-text', modelBuilder(val));
          });
          zeroClipboard = new ZeroClipboard(el);
          zeroClipboard.on('error', function(event) {
            //Triggered if flash is disabled or loading the directive inside an iFrame
            $log.info('ZeroClipboard error of type ' + event.name + ': ' + event.message);
            ZeroClipboard.destroy();
            watch();
            el.removeAttribute('data-clipboard-text');
            fallbackToNoFlashSolution();
          });
          function dummyBuilder(input) {
            return input;
          }
          function fallbackToNoFlashSolution() {
            if (!$window.Clipboard) {
              $log.info('Clipboard object not loaded.');
              elem.addClass('disabled');
              return;
            }
            new Clipboard(el);
          }
        },
      };
    }
    copyToClipboard.$inject = ['$window', '$log'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui').filter('toSnakeCase', toSnakeCase);
    /** @ngInject **/
    function toSnakeCase() {
      var filter = function(input) {
        if (input && input.indexOf('_') !== -1) {
          return input.replace(/_/g, '-');
        }
        return input;
      };
      return filter;
    }
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui').factory('BaseModalService', ModalService);
    /** @ngInject **/
    function ModalService($uibModal, $window) {
      var modal = angular.copy($uibModal),
        urlPrefix = $window.document.body.getAttribute('data-app-cdn') || '/';
      modal.isOpened = false;
      modal.modalInstance = null;
      modal.openJustOne = openJustOne;
      modal.openConfirmDialogModal = openConfirmDialogModal;
      return modal;
      function openJustOne(options) {
        if (!modal.isOpened) {
          modal.isOpened = true;
          modal.modalInstance = modal.open(options);
          modal.modalInstance.result['finally'](function() {
            modal.isOpened = false;
          });
        }
      }
      function openConfirmDialogModal(size) {
        var options = {
          templateUrl: urlPrefix + 'views/modal/confirm-dialog-modal.html',
          controller: 'ConfirmDialogModalController as dialogModal',
          size: size,
        };
        return modal.openJustOne(options);
      }
    }
    ModalService.$inject = ['$uibModal', '$window'];
  })();
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.ui').factory('NotificationService', NotificationService);
    /** @ngInject **/
    function NotificationService() {
      var service;
      service = {
        success: success,
        info: info,
        error: error,
        warning: warning,
        clear: clear,
      };

      const defaultOptions = {
          preventDuplicates: true,
          positionClass: 'toast-top-left',
          showMethod: 'slideDown',
          hideMethod: 'hide',
          showEasing: 'linear',
          timeOut: 3000,
          progressBar: true
      }
      return service;

      function success(text, title = 'Success', options = defaultOptions) {
        toastr.success(text, title, options);
      }
      function info(text, title = 'Info', options = defaultOptions) {
        toastr.info(text, title, options);
      }
      function error(text, title = 'Error', options =defaultOptions) {
        toastr.error(text, title, options);
      }
      function warning(text, title = 'Warning', options = defaultOptions) {
        toastr.warning(text, title, options);
      }
      function clear() {
        toastr.clear();
      }
    }
  })();
})(window, undefined);



// WEBPACK FOOTER //
// ./src/app/vendor/ec-fe-bo-template/dist/ui/ui.max.js